export function splitAmount(amount, parts) {
    const totalCents = Math.round(amount * 100);
    const base = Math.floor(totalCents / parts);
    const remainder = totalCents % parts;
    const result = [];
    for (let i = 0; i < parts; i++) {
        // distribute the leftover cents starting from the first payments
        const share = base + (i < remainder ? 1 : 0);
        result.push(share / 100);
    }
    return result;
}
